import React from 'react'
import PageContent from 'components/common/PageContent'
import ServicesTable from 'components/services/ServicesTable'

export default function Services(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Services"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <ServicesTable />
        </PageContent>
    );
}